import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {KTSVG} from '../../../_metronic/helpers'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {contractSelector, setSort} from '../../../redux/slices/contractSlices'

export const RowHeadTableContract = memo(() => {
  const {t} = useTranslation()
  const {sort} = useAppSelector(contractSelector)
  const dispatch = useAppDispatch()

  const ActionIconSortPONumber = () => {
    const path =
      sort?.po_number_orderby === 'asc'
        ? '/media/icons/duotune/sort-down-alt.svg'
        : '/media/icons/duotune/sort-up-alt.svg'

    const handleClick = () => {
      dispatch(
        setSort({
          ...sort,
          po_number_orderby: sort?.po_number_orderby === 'asc' ? 'desc' : '',
        })
      )
    }

    return (
      <button
        className='bg-transparent border-0'
        data-bs-toggle='tooltip'
        data-bs-placement='top'
        data-bs-trigger='hover'
        title={t('Sort')}
        onClick={handleClick}
      >
        <KTSVG path={path} className='svg-icon-3 ms-1' />
      </button>
    )
  }

  const ActionIconSortCustomer = () => {
    const path =
      sort?.customer_name_orderby === 'asc'
        ? '/media/icons/duotune/sort-down-alt.svg'
        : '/media/icons/duotune/sort-up-alt.svg'

    const handleClick = () => {
      dispatch(
        setSort({
          ...sort,
          customer_name_orderby: sort?.customer_name_orderby === 'asc' ? 'desc' : 'asc',
        })
      )
    }

    return (
      <button
        className='bg-transparent border-0'
        data-bs-toggle='tooltip'
        data-bs-placement='top'
        data-bs-trigger='hover'
        title={t('Sort')}
        onClick={handleClick}
      >
        <KTSVG path={path} className='svg-icon-3 ms-1' />
      </button>
    )
  }

  return (
    <tr>
      <th>
        {t('kontrak-nomor')}
        <ActionIconSortPONumber />
      </th>
      <th>{t('SAP Number')}</th>
      <th>
        {t('order-pelanggan')}
        <ActionIconSortCustomer />
      </th>
      <th>{t('order-perihal')}</th>
      <th>{t('Sektor')}</th>
      <th>Sales Org</th>
      <th>{t('Order Number')}</th>
      <th>{t('SIP Number')}</th>
      <th>{t('kontrak-tanggal')}</th>
      <th>{t('Start-Date')}</th>
      <th>{t('End-Date')}</th>
      <th>{t('sub-order-jenis')}</th>
      <th>Total {t('kontrak-kuantum')}</th>
      <th>Total {t('kontrak-harga')}</th>
      <th>{t('Metode Pembayaran')}</th>
      <th>Status</th>
      <th>{t('kontrak-aksi')}</th>
    </tr>
  )
})
